export const emptyContact = { name: "", email: "", phone: "" }

export const emptyContactBoat = {
  name: "",
  boat_type: "",
  length_overall: 0,
  beam: 0,
  draw: 0,
  height: 0,
  make: "",
  model: "",
  year: "",
  hailing_port: "",
  hull_identification: "",
  registration_attributes: { number: "" },
}
